import { getImageData } from "gatsby-plugin-image";

import { StorefrontImage } from "../types";

export type VinoDataImage = {
  width: number;
  height: number;
  url: string;
};

interface StorefrontImageOptions {
  width?: number;
  height?: number;
}

export const generateStorefrontImage = (
  image: VinoDataImage,
  options: any = {}
): StorefrontImage => {
  if (!image || !image.url) return undefined;

  return getImageData({
    baseUrl: image.url,
    urlBuilder: ({ baseUrl, width, height, format }): string =>
      `${baseUrl}?w=${width}&h=${height}&fm=${format}`,
    sourceWidth: image.width,
    sourceHeight: image.height,
    formats: ["jpg", "webp"],
    ...options,
  });
};

export const generateStorefrontImageFromSrc = (
  src: string,
  options: StorefrontImageOptions = { width: 2100, height: 700 }
): StorefrontImage => {
  if (!src) return undefined;

  return getImageData({
    baseUrl: src,
    urlBuilder: ({ baseUrl, width, height, format }): string =>
      `${baseUrl}?w=${width}&h=${height}&fm=${format}`,
    sourceWidth: options.width,
    sourceHeight: options.height,
    formats: ["jpg", "webp"],
    ...options,
  });
};
